// extracted by mini-css-extract-plugin
module.exports = {"image":"_3MlPn","title-wrapper":"odIrv","titleWrapper":"odIrv","slide":"W-Mdj","teaser":"_1RGhB","box":"_3T4qo","imgWrapper":"_3Ttg4","boxContent":"_3pMAJ","solutionName":"_2a3tB"};